module.exports = __webpack_public_path__ + "static/img/ai_icon.26fa76eb.png";